import { SideMenuItemViewModel } from '~/features/navigation';
import { runtimeConfig } from '~/shared/utils/public-variables';
import { Fetch } from '~/lib/models/fetch';
import { printQuery } from './utils/print-query';

const { API_URL } = runtimeConfig();

export type SideMenuRequestPath = {
    franchise: number;
    culture: string;
    headers?: HeadersInit;
    opts?: RequestInit;
};

export type SideMenuResponseType = SideMenuItemViewModel[];

/**
 * Helper method for fetching side menu structure
 *
 * @param franchise Additional param for the url
 * @param culture Additional param for the url
 * @param headers Headers to append
 */
async function sideMenuFetcher<T>(
    franchise: number,
    culture: string,
    headers: HeadersInit = {}
): Promise<Fetch<T>> {
    // Build url
    const url = `${API_URL}/api/${franchise}/${culture}/sidebar`;

    printQuery(url, headers);

    const response = await fetch(url, {
        method: 'GET',
        headers: {
            ...headers,
            'Content-Type': 'application/json; charset=utf-8',
        },
        keepalive: true,
    });

    const { status, statusText } = response;

    if (status >= 500) {
        console.error(`Failed to fetch Side Menu Structure with url:${url}`);
        console.error(statusText);
    }

    return response;
}

/**
 * Fetch Side Menu Structure
 */
export async function getSideMenu(
    franchise: number,
    culture: string,
    headers?: HeadersInit
): Promise<SideMenuResponseType> {
    const response = await sideMenuFetcher<SideMenuResponseType>(franchise, culture, headers);
    return response.json();
}
